import { render, staticRenderFns } from "./MarketBoundaries.vue?vue&type=template&id=86f630da&"
import script from "./MarketBoundaries.vue?vue&type=script&lang=js&"
export * from "./MarketBoundaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports